export const DEFAULT_THUMBNAIL_SIZE = 48;
